var _path, _path2, _rect, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRoughCaverns = function SvgRoughCaverns(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.11 5H27.5L43 27.5 35 43H12.5L5 20zm1.39 3-9 12.5L15 40h18l6.5-12.227L26 8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.11 5H27.5L43 27.5 35 43H12.5L5 20zm.828 1.5L6.665 20.176 13.549 41.5h20.53l7.187-13.812L26.902 6.5z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28.919,
    y: 23.313,
    transform: "rotate(100 28.92 23.313)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m26.6 21.341-1.91 10.833-.985-.174 1.91-10.833zM24.282 19.367 22.372 30.2l-.985-.174 1.91-10.833zM21.964 17.394l-1.91 10.833-.985-.174 1.91-10.833zM19.646 15.421l-1.91 10.833-.985-.174 1.91-10.833z"
  })));
};
export default SvgRoughCaverns;